import { createAction } from '@reduxjs/toolkit';

// Interfaces
import { Constants } from './constants';
import { ISenderInfo, ISenderLogo, ISenderOrganizationInfo } from '../../interfaces/sender.interfaces';

export const addSenderLogo = createAction(Constants.ADD_SENDER_LOGO, (senderLogo: ISenderLogo) => ({
    payload: { senderLogo },
}));

export const addSenderInfoList = createAction(Constants.ADD_SENDERINFO_LIST, (senderInfoList: ISenderInfo[]) => ({
    payload: { senderInfoList },
}));

export const addSenderOrganisationInfo = createAction(
    Constants.ADD_SENDER_ORGANIZATION_LIST,
    (senderOrganizationList: ISenderOrganizationInfo[]) => ({
        payload: { senderOrganizationList },
    })
);

export const setSelectedSenderName = createAction(
    Constants.ADD_SELECTED_SENDER,
    (SelectedSender: any, isSenderClicked: boolean) => ({
        payload: { SelectedSender, isSenderClicked },
    })
);
